import React from 'react'
import SvgIcon from '@mui/material/SvgIcon';
import useStore from '../Store';
import {colors} from '../colors'


export default function Logo({scale=1.0}){
  const {colorTheme } = useStore();

return(
  <SvgIcon sx={{transform: `scale(${scale})`}}>
    <svg width="284" height="284" viewBox="0 0 284 284" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="142" cy="142" r="140" fill={`${colors[colorTheme].default}`} stroke={`${colors[colorTheme].logo}`} stroke-width="1"/>
      <path d="M118.5 61.5L93.5 72V222H118.5V61.5Z" fill={`${colors[colorTheme].logo}`}/>
      <path d="M95.5 220.5V73.305L118.82 63.0444L169 68.3014V220.5H95.5Z" stroke={`${colors[colorTheme].logo}`} stroke-width="8"/>
      <path d="M128 220.5L128 139.556L157.645 132.027L207.5 137.3V220.5H128Z" fill="white" stroke={`${colors[colorTheme].logo}`} stroke-width="8"/>
      <path d="M126.5 139.574C126.5 138.65 127.132 137.847 128.03 137.63L157.5 130.5V222H128.5C127.395 222 126.5 221.104 126.5 220V139.574Z" fill={`${colors[colorTheme].logo}`}/>
    </svg>
  </SvgIcon>
)
}


